<template>
<div>
    <!-- <TheNavigationPanel/> -->
    <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
        <v-toolbar flat color="#F0FFEA" height="40" >
            <v-toolbar-title style="color:#62AE32" class="headline">{{communityName}}</v-toolbar-title>
        </v-toolbar>       
        
        <div class="mt-6">
            <v-card class="ml-4" color="#F0FFEA" max-width="500" flat> 
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            readonly
                            solo
                            flat
                            dense
                            v-model="fname"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Username</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label=""
                            readonly
                            solo
                            flat
                            dense
                            v-model="name"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Policy Number</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="policyId"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Name of Car</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="carModel"
                            style="font-size:14px"
                            class="black-text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Car Color</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="carColor"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Engine No</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="engineNumber"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">VIN</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="vin"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Car Valuation Amount</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            prepend-inner-icon="mdi-currency-ngn"
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="carPrice"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Premium</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            prepend-inner-icon="mdi-currency-ngn"
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="premium"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Status</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="status"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Subscription Date</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="date"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Date Paid</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="datePaid"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row> 
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Expiry Date</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="expiryDate"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mb-n3">
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Expired</span>                  
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            readonly
                            label=""
                            solo
                            flat
                            dense
                            v-model="expired"
                            style="font-size:14px"
                            class="black--text"
                        ></v-text-field>
                    </v-col>
                </v-row> 
                <!-- Images -->
                         <v-dialog v-model="dialog1" max-width="50vw" >
                            <img :src="src" alt="" width="100%" @click.stop="dialog1=false">
                        </v-dialog>
                        <v-row>
                            <v-col cols="12" sm="12" >
                            <v-card>
                                <v-card-title>
                                    <span style="font-size:14px; color:#615D5D">Policy files</span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-container fluid>
                                <v-row>
                                    <v-col
                                    v-for="img in PolicyImages"
                                    :key="img.url"
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(img.vehicle_image)"
                                        :lazy-src="img.url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(img.vehicle_image)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                    </v-card>
                                    </v-col>
                                    <v-col
                                    v-for="img in PolicyImages"
                                    :key="img.url"
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(img.utility_bill_url)"
                                        :lazy-src="img.url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(img.utility_bill_url)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                    </v-card>
                                    </v-col>
                                     <v-col
                                    v-for="img in PolicyImages"
                                    :key="img.url"
                                    class="d-flex child-flex"
                                    cols="4"
                                    >
                                    <v-card flat tile class="d-flex">
                                        <v-img
                                        :src="getImgUrl(img.driver_license_url)"
                                        :lazy-src="img.url"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                        @click="zoom(img.driver_license_url)"
                                        style="cursor:pointer"
                                        >
                                        </v-img>
                                    </v-card>
                                    </v-col>
                                </v-row>
                                </v-container>
                            </v-card>
                            </v-col>
                        </v-row>            
            </v-card>
              
                </div>     
    </div>
    </v-container>

</div>
   
</template>
<script>
    // import TheNavigationPanel from '../components/TheNavigationPanel';

    export default {
        name: 'communityMembers',
        components: {
            // TheNavigationPanel,
        },

        data: () => ({
            date:'',
            expiryDate:'',
            datePaid:'',
            id:2,
            fname:'',
            name: '',
            dialog:false,
            dialog1:false,
            src: '',
            policyId:"90121",
            carModel:"Lexus 2013",
            carColor:"Blue",
            engineNumber:"098BGH876HF4309",
            vin:"010101",
            carPrice:"4,000,000",
            premium:"50,000",
            status:"Not Verified",
            expired:'',
             images:[
                {id:1, url:'/car4.jpg'},
                {id:2, url:'/car1.jpg'},
                {id:3, url:'/car2.jpg'}
            ],
            communityName:'',
            // url:"http://192.168.1.115:3000"
            // url:"https://cover-my-car.herokuapp.com"
            url:"https://res.cloudinary.com/dmnghlyic/image/upload/v1587634815/"

        }),
        computed:{
            PolicyImages(){
               return this.$store.state.community.viewpolicy 
            }
        },
        methods: {
             zoom(url){
                let imgUrl=url
                // alert(imgUrl)
                console.log(imgUrl);
                this.src = this.url+imgUrl
                this.dialog1=true
            },
        getImgUrl(pic) {
        let weblink = this.url;
        return weblink+pic;
        },
        },
        created(){
            this.name = this.$store.state.community.viewpolicy[0].username
            this.communityName = this.$store.state.community.viewpolicy[0].community_name
            this.policyId = this.$store.state.community.viewpolicy[0].policy_number
            this.carModel = this.$store.state.community.viewpolicy[0].vehicle_make
            this.carColor = this.$store.state.community.viewpolicy[0].vehicle_color
            this.engineNumber = this.$store.state.community.viewpolicy[0].engine_number
            this.vin = this.$store.state.community.viewpolicy[0].VIN
            // this.carPrice = this.$store.state.community.viewpolicy[0].valuation_amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.carPrice = parseFloat(this.$store.state.community.viewpolicy[0].valuation_amount).toFixed(2)
            this.carPrice = this.carPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            // this.premium = this.$store.state.community.viewpolicy[0].premium.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.premium = parseFloat(this.$store.state.community.viewpolicy[0].premium).toFixed(2)
            this.premium = this.premium.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.status = this.$store.state.community.viewpolicy[0].status
            this.fname = this.$store.state.community.viewpolicy[0].name
            if (this.$store.state.community.viewpolicy[0].is_expired==="0"){
                this.expired="No"
            }else{
                this.expired="Yes"
            }
            this.date = this.$store.state.community.viewpolicy[0].date_created.slice(0, 19).replace('T', ' ');
            this.datePaid = this.$store.state.community.viewpolicy[0].date_paid.slice(0, 19).replace('T', ' ');
            this.expiryDate= this.$store.state.community.viewpolicy[0].expiry_date.slice(0, 19).replace('T', ' ');
            
            
        }  
    }
</script>